import React from 'react'
import { Link } from 'react-router'
import { Container, Row, Col, Button, InputGroup, InputGroupAddon, Input, Label, FormGroup } from 'reactstrap';

import Loader from '../../../core/components/Loader'


class NetworkChoice extends React.Component {

	constructor(props) {
		  super(props);
		  this.state={
		  	network:null
		  }
	}

	choiceNetwork(){
		if(this.state.network)
			this.props.onSubmit(this.state.network)
	}


	render(){
		const { provider, status } = this.props

		return(
			<div className="background-white">
                  <div className="login-page status-page">
                    
                        <Row>
                            <Col>
                                <div className="bloc-right center close" onClick={() => this.props.onClose()}>X</div>
                            </Col>
                        </Row>

                        <div className="login-container">
                            <Row>
                                <Col>
                                    <div className="login-title">Statut de candidature</div>
                                    <div className="login-company"> {provider.company} </div>
                                    <div className="login-subitle">Veuille choisir le reseau dans lequel le prestataire sera affecté </div>
                                </Col>
                            </Row>

                            <div className="bloc-login">
				                <form  role="form" >

				                        <FormGroup check>
								            <Label check>
								              <Input type="radio" name="radio1" onChange={() => this.setState({network:"BAU"})} />{' '}
								              Réseau Agréé
								            </Label>
							           </FormGroup>

							           <FormGroup check>
								            <Label check>
								              <Input type="radio" name="radio1" onChange={() => this.setState({network:"1MV"})} />{' '}
								              Réseau 1MV
								            </Label>
							           </FormGroup>
				                     
				                     {status.pending && 
				                     	<Loader />
				                     ||      
					                     <div className="center validate">
					                        <Button className="btn-green" onClick={() => this.choiceNetwork() }>Valider</Button>
					                     </div>
				                     } 

				                </form>
				            </div>

                        </div>

                        <Row className="bloc-register center">
                            <Col>
                                <div className="register-subtitle"><a onClick={() => this.props.onBack()}>Retour à l'étape précédente</a></div>
                            </Col>
                        </Row>

                  </div>
            </div>
		)
	}
}


export default NetworkChoice


// WEBPACK FOOTER //
// ./src/provider/components/status/NetworkChoice.js